module.exports = __webpack_public_path__ + "static/equipe_gastrocirurgica_cirurgia-369811418f8c8e1b6b2f36d6ad693a95.png";